export default function extractTedVideoSlug(url: string): string {
  const finalBackslashIndex = url.lastIndexOf("/");
  return finalBackslashIndex === -1
    ? url
    : url.substring(finalBackslashIndex + 1);
}
